import { IoBusinessOutline, IoCallOutline, IoCreateOutline, IoLocationOutline, IoMailOutline, IoPersonOutline, IoRibbonOutline } from "react-icons/io5";
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { useState } from "react";
import SkillsModal from "../Modals/Skills";

function ContactRow({ icon, k, v }) {
  return (
    <div className="emp-contact-row">
      <div className="emp-contact-icon">{icon}</div>
      <div className="emp-contact-meta">
        <div className="k">{k}</div>
        <div className="v">{v}</div>
      </div>
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div>
      <div className="emp-field-label">{label}</div>
      <div className="emp-field-value">{value}</div>
    </div>
  );
}

function OverviewTab({ employeeData, refreshEmployeeData }) {
  const location = [employeeData.city, employeeData.country].filter(Boolean).join(", ") || "";
  const [skillsModalOpen, setSkillsModalOpen] = useState(false);

  return (
    <div className="emp-grid">
      {/* Left column */}
      <div>
        <Card className="mb-3">
          <CardHeader>
            <CardTitle>
              <IoMailOutline size={18} /> Contact
            </CardTitle>
          </CardHeader>
          <CardBody style={{ paddingTop: 6, paddingBottom: 6 }}>
            <ContactRow icon={<IoMailOutline size={17} />} k="Work email" v={employeeData.email} />
            <ContactRow icon={<IoCallOutline size={17} />} k="Phone" v={employeeData.country_code + ' ' + employeeData.phone_number} />
            <ContactRow icon={<IoLocationOutline size={17} />} k="Location" v={location} />
          </CardBody>
        </Card>

        <Card>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <CardTitle>
              <IoRibbonOutline size={18} /> Skills
            </CardTitle>
            <button type="button" className="emp-link-btn" onClick={() => setSkillsModalOpen(true)}>
              <IoCreateOutline size={14} /> Edit
            </button>
          </CardHeader>
          <CardBody>
            <div className="emp-tags">
              {employeeData?.skills?.map(
                (s) => (
                  <span key={s.id} className="emp-tag">{s.skill_name}</span>
                )
              )}
            </div>
          </CardBody>
        </Card>
      </div>

      {/* Right column */}
      <div>
        <Card className="mb-3">
          <CardHeader>
            <CardTitle>
              <IoPersonOutline size={18} /> Personal details
            </CardTitle>
          </CardHeader>
          <CardBody>
            <div className="emp-fields">
              <Field label="Date of birth" value={employeeData.birthdate} />
              <Field label="Gender" value={employeeData.gender} />
              <Field label="Marital status" value={employeeData.marital_status} />
              <Field label="Nationality" value={employeeData.country} />
              <Field label="National ID" value={employeeData.id_type} />
              <Field label="Blood group" value={employeeData.blood_group} />
            </div>
          </CardBody>
        </Card>

        <Card className="mb-3">
          <CardHeader>
            <CardTitle>
              <IoBusinessOutline size={18} /> Job & organization
            </CardTitle>
          </CardHeader>
          <CardBody>
            <div className="emp-fields">
              <Field label="Job title" value={employeeData.job_title} />
              <Field label="Department" value={employeeData.department} />
              <Field label="Employment type" value={employeeData.work_schedule ?? '-'} />
              <Field label="Date joined" value={employeeData.contract_start_date} />
            </div>
          </CardBody>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>
              <IoCallOutline size={18} /> Emergency contact
            </CardTitle>
          </CardHeader>
          <CardBody>
            <div className="emp-fields">
              <Field label="Full name" value={employeeData.emergency_contact_name ?? '-'} />
              <Field label="Phone" value={employeeData.emergency_contact_phone_number ?? '-'} />
            </div>
          </CardBody>
        </Card>
      </div>

      <SkillsModal
        isOpen={skillsModalOpen} 
        toggle={() => {setSkillsModalOpen(!skillsModalOpen); refreshEmployeeData();}} 
        employeeData={employeeData}
      />
    </div>
  );
}

export default OverviewTab;